import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'

/* Views */
import BAIPaga from '@/views/payments/BAIPaga'
import BatchfileConsult from '@/views/payments/batchfile/Consult'
import BatchfileNewPayment from '@/views/payments/batchfile/NewPayment'
import Services from '@/views/payments/Services'
import UnitelFlow from '@/views/payments/flows/Unitel'
import EmisSpecialFlow from '@/views/payments/flows/EmisSpecial'
import ReferenceFlow from '@/views/payments/flows/Reference'
import VoucherFlow from '@/views/payments/flows/Voucher'
// import RupeFlow from '@/views/payments/flows/Rupe'
import RequestsBaiPaga from '@/views/payments/requests/BaiPaga'
import RequestsBaiPagaPay from '@/views/payments/requests/BaiPagaPay'
import PaymentsHistory from '@/views/payments/History'
import UnderDevelopment from '@/views/UnderDevelopment'

export default [{
	path: routeList.PAYMENTS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
},
{
	path: routeList.PAYMENTS_BAI_PAGA_PATH,
	name: routeList.PAYMENTS_BAI_PAGA_NAME,
	props: true,
	component: BAIPaga
},
/* ***********************************************
*                    BATCHFILE                   *
*********************************************** */
{
	path: routeList.PAYMENTS_BATCHFILE_PATH,
	name: routeList.PAYMENTS_BATCHFILE_NAME,
	component: BatchfileConsult
},
{
	path: routeList.PAYMENTS_BATCHFILE_NEW_PAYMENT_PATH,
	name: routeList.PAYMENTS_BATCHFILE_NEW_PAYMENT_NAME,
	component: BatchfileNewPayment
},
/* ***********************************************
*                     SERVICES                   *
*********************************************** */
{
	path: routeList.PAYMENTS_SERVICES_PATH,
	name: routeList.PAYMENTS_SERVICES_NAME,
	props: true,
	component: Services
},
{
	path: routeList.PAYMENTS_SERVICES_FLOW_EMIS_SPECIAL_PATH,
	name: routeList.PAYMENTS_SERVICES_FLOW_EMIS_SPECIAL_NAME,
	component: EmisSpecialFlow,
	props: true,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.PAYMENTS_SERVICES_NAME)
	}
},
{
	path: routeList.PAYMENTS_SERVICES_FLOW_EMIS_REFILL_PATH,
	name: routeList.PAYMENTS_SERVICES_FLOW_EMIS_REFILL_NAME,
	component: UnderDevelopment,
	props: true,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.PAYMENTS_SERVICES_NAME)
	}
},
{
	path: routeList.PAYMENTS_SERVICES_FLOW_EMIS_VOUCHER_PATH,
	name: routeList.PAYMENTS_SERVICES_FLOW_EMIS_VOUCHER_NAME,
	component: VoucherFlow,
	props: true,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.PAYMENTS_SERVICES_NAME)
	}
},
{
	path: routeList.PAYMENTS_SERVICES_FLOW_UNITEL_PATH,
	name: routeList.PAYMENTS_SERVICES_FLOW_UNITEL_NAME,
	component: UnitelFlow,
	props: true,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.PAYMENTS_SERVICES_NAME)
	}
},
/* ***********************************************
*                      MINFIN                    *
*********************************************** */
{
    path: routeList.PAYMENTS_MINFIN_PATH,
    name: routeList.PAYMENTS_MINFIN_NAME,
    component: EmisSpecialFlow,
    props: true
},
/* ***********************************************
*                   EMIS REFERENCE               *
*********************************************** */
{
    path: routeList.PAYMENTS_EKWANZA_PATH,
    name: routeList.PAYMENTS_EKWANZA_NAME,
    component: EmisSpecialFlow,
    props: true
},
{
    path: routeList.PAYMENTS_SERVICES_FLOW_EMIS_REFERENCE_PATH,
    name: routeList.PAYMENTS_SERVICES_FLOW_EMIS_REFERENCE_NAME,
    component: ReferenceFlow,
    props: true,
    beforeEnter (to, from, next) {
        validateRouteMandatoryProps(to, from, next, routeList.PAYMENTS_SERVICES_NAME)
    }
},
/* ***********************************************
*                      EKWANZA                   *
*********************************************** */
{
    path: routeList.PAYMENTS_EMIS_REFERENCE_PATH,
    name: routeList.PAYMENTS_EMIS_REFERENCE_NAME,
    component: ReferenceFlow
},
/* ***********************************************
*                     REQUESTS                   *
*********************************************** */
{
	path: routeList.PAYMENTS_REQUESTS_PATH,
	name: routeList.PAYMENTS_REQUESTS_NAME,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.PAYMENTS_REQUESTS_BAI_PAGA_PATH,
	name: routeList.PAYMENTS_REQUESTS_BAI_PAGA_NAME,
	component: RequestsBaiPaga
}, {
	path: routeList.PAYMENTS_REQUESTS_BAI_PAGA_PAY_PATH,
	name: routeList.PAYMENTS_REQUESTS_BAI_PAGA_PAY_NAME,
	props: true,
	component: RequestsBaiPagaPay,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.PAYMENTS_REQUESTS_BAI_PAGA_NAME)
	}
}, {
	path: routeList.PAYMENTS_REQUESTS_EKWANZA_PATH,
	name: routeList.PAYMENTS_REQUESTS_EKWANZA_NAME,
	component: UnderDevelopment
}, {
	path: routeList.PAYMENTS_HISTORY_PATH,
	name: routeList.PAYMENTS_HISTORY_NAME,
	component: PaymentsHistory
}]
